'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Loading = require('./Loading');

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Loading2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bee-loading/build/index.js
// module id = 445
// module chunks = 0